import { create } from 'zustand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';

const defaultState: UserStoreState = {
    accessToken: '',
    mallUserId: '',
    expiresIn: ''
};
export const useUserStore = create<UserStoreState & UserStoreAction>()(
    persist(
        (set) => ({
            ...defaultState,
            reset: () => {
                set(() => ({ ...defaultState }))
            },
        }),
        {
            name: 'user-storage',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);

export const useAnonymousUserStore = create<UserStoreState & UserStoreAction>()(
    persist(
        (set) => ({
            ...defaultState,
            reset: () => {
                set(() => ({ ...defaultState }))
            },
        }),
        {
            name: 'anonymousUser-storage',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);

export interface UserStoreState {
    accessToken: string;
    mallUserId: string;
    expiresIn: string;
}
export interface UserStoreAction {
    reset: () => void;
}
